import { COLORS, pickThemeFontSize, pickThemeFontStyles } from '@/theme';
import { styled } from 'styled-components';
import { Link } from 'react-router-dom';

export const StyledChannelTag = styled.span`
  display: inline-flex;
  border-radius: 999px;
  align-items: center;
  padding: 0.25rem 0.625rem;
  ${pickThemeFontStyles('12', '16', 'SEMI_BOLD')}
  color: #475467;
  background-color: #eef1f4;
`;

export const StyledTruncate = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledQuestion = styled(StyledTruncate)`
  font-weight: 500;
`;

export const StyledAnswer = styled(StyledTruncate)`
  color: ${COLORS.GRAY_6};
`;

export const StyledDate = styled.span`
  color: ${COLORS.GRAY_6};
`;

export const StyledSearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;

  input,
  .ant-select {
    width: 100% !important;
  }

  .ant-select-selection-placeholder {
    font-weight: 400;
  }

  input.ant-input {
    font-size: ${pickThemeFontSize('14')};
  }
`;

export const StyledConversationId = styled(Link)`
  ${pickThemeFontStyles('14', '18', 'BOLD')}
  color: ${({ theme }) => theme?.token?.colorPrimary};
  text-decoration: none !important;

  &:is(:hover, :focus, :active, :visited) {
    color: ${({ theme }) => theme?.token?.colorPrimary};
    text-decoration: none !important;
  }
`;
